import React, { useState, useEffect } from 'react';
import '../Inicio/Inicio.css';

import img1 from '../../img/Inicio/Fondo/1.JPG';
import img2 from '../../img/Inicio/Fondo/2.JPG';
import img3 from '../../img/Inicio/Fondo/3.JPG';
import img4 from '../../img/Inicio/Fondo/4.JPG';
import logo from '../../img/Logo/tmologo.png';
import estam from '../../img/Inicio/Servicios/estampado.jpg';
import estam2 from '../../img/Inicio/Servicios/estampado2.jpg';
import dobtubo from '../../img/Inicio/Servicios/dobtubo.jpg';
import doblam from '../../img/Inicio/Servicios/doblamina.jpg';
import Solrobot from '../../img/Inicio/Servicios/Solrobot.jpg';
import recubri from '../../img/Inicio/Servicios/recubrimiento.JPG';
import recu2 from '../../img/Inicio/Servicios/recubri2.JPEG';
import rolamina from '../../img/Inicio/Servicios/R-101.png';
import lamina from '../../img/Inicio/Servicios/Lamina.png';
import nueva1 from '../../img/Certificaciones/EANOR.png';
import nueva2 from '../../img/Certificaciones/ISO.png';
import nueva3 from '../../img/Certificaciones/Hechoenmexico.png';
import esr from '../../img/Certificaciones/Empresasocialmenteresponsable.png';
import hem from '../../img/Certificaciones/HECHO EN MÉXICO.png';
import roseta from '../../img/Nosotros/Fondo/Roseta gift.gif'
import laser from '../../img/Servicios/cortelaser.png';
import manual from '../../img/Servicios/manual.JPEG';
import zinc from '../../img/Servicios/zinc.jpg'
import { useNavigate, Link } from "react-router-dom";
import aviso from '../doc/Aviso de Privacidad TMO.pdf'
import termino from '../doc/Terminos y Condiciones TMO.pdf'


// import cliente1 from '../../img/clientes/cliente1.png';
// import cliente2 from '../../img/clientes/cliente2.png';
// import cliente3 from '../../img/clientes/cliente3.png';

import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


const fondoSecuencial = [img1, img2, img3, recubri, img4];

const Inicio = () => {
    const [imageToShow, setImageToShow] = useState(img1);
    const [esAniversario, setEsAniversario] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const index = Math.min(
                fondoSecuencial.length - 1,
                Math.floor(scrollTop / 500)
            );
            setImageToShow(fondoSecuencial[index]);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const hoy = new Date();
        if (hoy.getDate() === 11 && hoy.getMonth() === 10) {
            setEsAniversario(true);
        }
    }, []);

    const calcularAnios = () => {
        const fechaInicio = new Date(2011, 10, 11);
        const hoy = new Date();
        let anios = hoy.getFullYear() - fechaInicio.getFullYear();
        const cumpleEsteAnio = new Date(hoy.getFullYear(), 10, 11);

        if (hoy < cumpleEsteAnio) {
            anios -= 1;
        }
        return anios;
    };

    const [rotation, setRotation] = useState(0);

    const images = [nueva2, nueva1, nueva3];
    const [activeIndex, setActiveIndex] = useState(0);

    const prev = () => {
        setActiveIndex((activeIndex - 1 + images.length) % images.length);
    };

    const next = () => {
        setActiveIndex((activeIndex + 1) % images.length);
    };

    const Carrusel = () => {
        useEffect(() => {
            const el = document.querySelector('#carouselCorteLaser');
            if (el) {
                const carousel = new window.bootstrap.Carousel(el, {
                    interval: 3000,
                    ride: 'carousel',
                });
            }
        }, []);

        return (
            <div
                id="carouselCorteLaser"
                className="carousel slide carousel-fade"
                data-bs-ride="carousel"
                data-bs-interval="3000"
            >
                {/* carousel-inner aquí */}
            </div>
        );
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000); // puedes cambiar el tiempo si lo deseas
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="preloader">
                <img src={roseta} loading="lazy" alt="Cargando..." className="gif-preloader" />
            </div>
        );
    }
    

    return (
        <div className="inicio-container">
            {esAniversario && (
                <div className="fireworks-background" />
            )}

            <div className="fondo-global" style={{ backgroundImage: `url(${imageToShow})` }}>
                <div className="capa-negra" />
            </div>

            <div className="barra-superior-completa">
                <div className="barra-superior">
                    <div className="horario-contacto">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> Lun-Vie: 8:00 - 17:00</span>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> 55 8854 5539</span>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> contacto@troqueladosmodulares.com.mx</span>
                    </div>
                </div>

                <div className="barra-logo-iconos">
                    <div className="logo-superior">
                        <Link to={'/'}>
                        <img loading="lazy" src={logo} alt="Logo" />
                        </Link>
                    </div>
                    <div className="iconos">
                        <a
                            href="https://wa.me/525643108583"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="icono">
                                {/* WhatsApp */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                </svg>
                            </span>
                        </a>

                        <a href="tel:+525588545539">
                            <span className="icono">
                                {/* Teléfono */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-phone-fill" viewBox="0 0 16 16">
                                    <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
                                </svg>
                            </span>
                        </a>

                        <a
                            href="mailto:contacto@troqueladosmodulares.com.mx"
                            className="icono"
                            title="Enviar correo a contacto@troqueladosmodulares.com.mx"
                        >
                            {/* Correo */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                            </svg>
                        </a>

                        <Link to={'/contacto'}>
                            <span className="icono">
                                {/* Ubicación */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                                </svg>
                            </span>
                        </Link>

                    </div>
                </div>

                <nav className="navbar navbar-expand-lg custom-navbar">
                    <div className="container-fluid">
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav mx-auto">
                                <Link to={'/'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link active">Inicio</a></li></Link>
                                <Link to={'/nosotros'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link">Nosotros</a></li></Link>
                                <Link to={'/servicios'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#servicios">Servicios</a></li></Link>
                                <Link to={'/certificaciones'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link">Certificaciones</a></li></Link>
                                <Link to={'/contacto'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#contacto">Contacto</a></li></Link>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>

            {/* Carrusel */}
            <div id="carouselInicio" className="carousel slide carrusel-inicio" data-bs-ride="carousel" data-bs-interval="5000">
                {/* Indicadores (círculos) */}
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselInicio" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselInicio" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselInicio" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>

                {/* Slides del carrusel */}
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <div className="carrusel-imagen-con-capa">
                            <img src={img2} loading="lazy" className="d-block w-100" alt="Imagen 1" />
                            <div className="capa-negra-carrusel">
                                <div className="texto-carrusel">
                                    <h2>FABRICANDO TUS IDEAS</h2>
                                    <br />
                                    <p style={{ textAlign: 'justify' }}>
                                        <ul>
                                            <li> Brindamos soluciones innovadoras con precisión y experiencia.</li>
                                            <li> Nos consolidamos como una empresa con crecimiento sostenido, ampliando nuestras oportunidades de mercado con una visión socialmente responsable</li>
                                            <li> Adaptamos nuestras soluciones a tus necesidades.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="carrusel-imagen-con-capa">
                            <img src={manual} loading="lazy" className="d-block w-100" alt="Imagen 2" />
                            <div className="capa-negra-carrusel">
                                <div className="texto-carrusel">
                                    <h2>SOLUCIONES DE FABRICACIÓN</h2>
                                    <br />
                                    <p style={{ textAlign: 'center' }}>
                                        Somos una empresa orgullosamente mexicana que brinda soluciones para la industria metal-mecánica mediante la estandarización de procesos,
                                        la aplicación de tecnología y talento especializado, para maximizar la calidad de nuestros servicios.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="carrusel-imagen-con-capa">
                            <img src={img4} loading="lazy" className="d-block w-100" alt="Imagen 3" />
                            <div className="capa-negra-carrusel">
                                <div className="contenedor-aniversario">
                                    <h2 className="texto-aniversario">
                                        <span className="anios">{calcularAnios()}</span> AÑOS DE EXPERIENCIA
                                    </h2>
                                    <h3>EN LA INDUSTRIA NOS RESPALDAN</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Botones de navegación izquierda/derecha */}
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselInicio" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Anterior</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselInicio" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Siguiente</span>
                </button>
            </div>

            <div className="valores-container">
                <div className="valores-marquee">
                    <div className="valores-track">
                        <span>Procesos Industriales</span>
                        <span>Eficiencia</span>
                        <span>Ingeniería</span>
                        <span>Calidad</span>
                        <span>Innovación</span>
                        <span>Experiencia</span>
                        {/* duplicado */}
                        <span>Procesos Industriales</span>
                        <span>Eficiencia</span>
                        <span>Ingeniería</span>
                        <span>Calidad</span>
                        <span>Innovación</span>
                        <span>Experiencia</span>
                    </div>
                </div>
            </div>

            {/* INICIA CARRUSELES DE SERVICIOS */}
            <Link to={'/servicios'} style={{ textDecoration: 'none' }}>
                <div className="estampado-section">
                    <div className="estampado-carrusel">
                        <div
                            id="carouselEstampadoMetalico"
                            className="carousel slide carousel-fade"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={estam} loading="lazy" className="d-block w-100" alt="Estampado Metálico 1" />
                                </div>
                                <div className="carousel-item">
                                    <img src={estam2} loading="lazy" className="d-block w-100" alt="Estampado Metálico 2" />
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselEstampadoMetalico"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Anterior</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselEstampadoMetalico"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Siguiente</span>
                            </button>
                        </div>

                    </div>
                    <div className="estampado-texto">
                        <h2>ESTAMPADO<br />METÁLICO</h2>
                    </div>
                </div>

                <div className="estampado-section">
                    <div className="estampado-texto">
                        <h2>CORTE LÁSER</h2>
                    </div>
                    <div className="estampado-carrusel">
                        <div
                            id="carouselCorteLaser"
                            className="carousel slide carousel-fade"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={laser} loading="lazy" className="d-block w-100" alt="Corte Láser 1" />
                                </div>
                                <div className="carousel-item">
                                    <img src={img2} loading="lazy" className="d-block w-100" alt="Corte Láser 2" />
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselCorteLaser"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Anterior</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselCorteLaser"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Siguiente</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="estampado-section">
                    <div className="estampado-carrusel">
                        <div
                            id="carouselDoblezTuboLam"
                            className="carousel slide carousel-fade"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={dobtubo} loading="lazy" className="d-block w-100" alt="Dobladora de Tubo" />
                                </div>
                                <div className="carousel-item">
                                    <img src={doblam} loading="lazy" className="d-block w-100" alt="Dobladora de Lámina" />
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselDoblezTuboLam"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Anterior</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselDoblezTuboLam"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Siguiente</span>
                            </button>
                        </div>
                    </div>
                    <div className="estampado-texto">
                        <h2>DOBLÉZ TUBO <br /> Y LÁMINA</h2>
                    </div>
                </div>

                <div className="estampado-section">
                    <div className="estampado-texto">
                        <h2>SOLDADURA MANUAL <br /> Y ROBOTIZADA</h2>
                    </div>
                    <div className="estampado-carrusel">
                        <div
                            id="carouselSoldadura"
                            className="carousel slide carousel-fade"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={Solrobot} loading="lazy" className="d-block w-100" alt="Soldadura 1" />
                                </div>
                                <div className="carousel-item">
                                    <img src={manual} loading="lazy" className="d-block w-100" alt="Soldadura 2" />
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselSoldadura"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Anterior</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselSoldadura"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Siguiente</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="estampado-section">
                    <div className="estampado-carrusel">
                        <div
                            id="carouselRecubrimiento"
                            className="carousel slide carousel-fade"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={zinc} loading="lazy" className="d-block w-100" alt="Recubrimiento " />
                                </div>
                                <div className="carousel-item">
                                    <img src={recu2} loading="lazy" className="d-block w-100" alt="Recubrimiento " />
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselRecubrimiento"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Anterior</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselRecubrimiento"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Siguiente</span>
                            </button>
                        </div>
                    </div>
                    <div className="estampado-texto">
                        <h2>RECUBRIMIENTO</h2>
                    </div>
                </div>

                <div className="estampado-section">
                    <div className="estampado-texto">
                        <h2>ROLADO DE LÁMINA <br /> R-101</h2>
                    </div>
                    <div className="estampado-carrusel">
                        <div
                            id="carouselRoladoLam"
                            className="carousel slide carousel-fade"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={rolamina} loading="lazy" className="d-block w-100" alt="Rolado Lámina 1" />
                                </div>
                                <div className="carousel-item">
                                    <img src={lamina} loading="lazy" className="d-block w-100" alt="Rolado Lámina 2" />
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselRoladoLam"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Anterior</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselRoladoLam"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Siguiente</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Link>

            {/* FIN DE CARRUSEL */}

            <br />
            <div className='GarCal'>
                <h2>GARANTÍA DE CALIDAD</h2>
            </div>
            <br />
            <br />
            <div className="slider3d-wrapper">
                <Link to={'/certificaciones'}>
                    <div className="slider3d">
                        {images.map((src, i) => {
                            let className = 'slider3d-image';
                            if (i === activeIndex) className += ' active';
                            else if (i === (activeIndex + 1) % images.length) className += ' right';
                            else if (i === (activeIndex - 1 + images.length) % images.length) className += ' left';
                            else className += ' hidden';

                            return (
                                <img
                                    loading="lazy"
                                    key={i}
                                    src={src}
                                    alt={`Certificación ${i + 1}`}
                                    className={className}
                                    draggable={false}
                                />
                            );
                        })}
                    </div>
                </Link>
                <div className="slider3d-controls">
                    <button onClick={prev}>‹</button>
                    <button onClick={next}>›</button>
                </div>
            </div>

            <footer className="footer">
                <div className="footer-top">
                    <p>55 8854 5539</p>
                </div>

                <div className="footer-content">
                    {/* Columna izquierda */}
                    <div className="footer-left">
                        <p>contacto@troqueladosmodulares.com.mx</p>
                        <p>Carretera México - Querétaro Km. 100, Jilotepec Edo. Méx.</p>
                        <img src={logo} loading="lazy" alt="Logo" className="footer-logo" />
                        <img src={esr} loading="lazy" alt="Logo" className="footer-logo" />
                        <a href="https://www.facebook.com/TMOMEX/" style={{ textDecoration: 'none', color: '#fff' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                            </svg>
                        </a>
                        <a href="https://www.linkedin.com/company/tmomex/" style={{ textDecoration: 'none', color: '#fff' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '20px' }} width="50" height="50" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                            </svg>
                        </a>
                    </div>

                    {/* Columna derecha */}
                    <div className="footer-right">
                        <p>  <a
                            href={aviso}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
                        >
                            Aviso de privacidad
                        </a></p>
                        <p>  <a
                            href={termino}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
                        >
                            Términos y Condiciones
                        </a></p>                        <p><a href="/contacto">Contáctanos</a></p>
                        <p>&copy; Troquelados modulares 2019</p>
                    </div>
                </div>
            </footer>

            <div style={{ height: '100%' }}></div>
        </div>
    );
};

export default Inicio;
